import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Loader2 } from "lucide-react";
import { PackView } from "./os/OSDirector";

export default function SharedPack() {
    const { token } = useParams();
    const [pack, setPack] = useState(null);
    const [state, setState] = useState("loading");
    const [lang, setLang] = useState("en");

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/os/director/shared/${token}`)
            .then((r) => { setPack(r.data); setState("ready"); })
            .catch(() => setState("error"));
    }, [token]);

    return (
        <div className="min-h-screen bg-[#0D0A08] text-[#F5F0E8] px-5 py-10 sm:py-16" data-testid="shared-pack-page">
            <div className="max-w-3xl mx-auto mb-10 flex items-center justify-between">
                <p className="text-[11px] uppercase tracking-[0.3em] text-[#D4A574] font-bold">slowcafe.kaily · Director Pack</p>
                <button onClick={() => setLang(lang === "en" ? "cn" : "en")} data-testid="shared-pack-lang"
                    className="rounded-full border border-white/15 px-4 py-1.5 text-[10.5px] uppercase tracking-[0.14em] font-bold text-[#F5F0E8]/60 hover:border-[#D4A574]">
                    {lang === "en" ? "中文" : "EN"}
                </button>
            </div>
            {state === "loading" && (
                <div className="text-center py-24 text-[#F5F0E8]/60"><Loader2 size={26} className="animate-spin mx-auto" /></div>
            )}
            {state === "error" && (
                <p className="text-center py-24 text-[#C0604A] text-[14px]" data-testid="shared-pack-error">This pack link is invalid or has been removed.</p>
            )}
            {state === "ready" && pack && <PackView pack={pack} lang={lang} shared />}
            {state === "ready" && (
                <p className="max-w-3xl mx-auto mt-16 pt-8 border-t border-white/8 text-center text-[11.5px] text-[#F5F0E8]/40">
                    Prepared by Kaily · slowcafe.kaily · F&B Commercial Director, KL/PJ
                </p>
            )}
        </div>
    );
}
